<template>
  <el-container class="wrapper">
    <a-locale-provider :locale="locale">
      <router-view>
      </router-view>
    </a-locale-provider>
  </el-container>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  export default {
    name: 'app',

    data () {
      return {
        locale: zhCN
      }
    },

    computed: {
    },

    methods: {
    },

    created () {
    },

    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/app.vue